var login = {
  translation: {
    common: {
      accept: '同意する',
      alreadyUser: 'すでにアカウントをお持ちですか？',
      and: 'および',
      backToLogin: 'ログインページに戻る',
      continueWith: '{{provider}}で続行',
      createAccount: 'アカウントを作成',
      createYourAccount: 'アカウントを作成する',
      emailOrUsername: 'メールアドレスまたはユーザー名',
      login: 'ログイン',
      logInToBoards: 'ログイン',
      newToBoards: '4ga Boardsは初めてですか?',
      pageNotFound_title: 'ページが見つかりません',
      password: 'パスワード',
      privacyPolicy: 'プライバシーポリシー',
      register: '登録',
      registerWithGoogle: 'Googleで登録',
      termsOfService: '利用規約',
      togglePasswordVisibility: 'パスワードの表示/非表示',
    },

    action: {
      logIn: 'ログイン',
    },
  },
};

export { login as default };
